import bodyweightTrack from "./strengthForLifeBodyweight.json";
import dumbbellTrack from "./strengthForLifeDumbbells.json";
import resistanceBandTrack from "./strengthForLifeResistanceBands.json";

const strengthForLifeData = {
    id: "strength-for-life",
    badge: "💪 12 Weeks",
    title: "Strength for Life",
    subtitle: "A beginner-friendly strength program with bodyweight, dumbbell, and resistance band tracks you can follow at home.",
    overview: {
        title: "📋 Program Overview",
        description: "Strength for Life is a 12-week beginner strength program designed to help you move with more confidence and feel stronger in everyday life. Pick the track that matches the equipment you have, follow three workouts per week, and progress through the three phases over 12 weeks.",
        video: {
            src: "https://player.vimeo.com/video/1185199683?badge=0&autopause=0&player_id=0&app_id=58479",
            title: "Health-hub-strength-for-life-intro",
        },
    },
    weeks: [
        bodyweightTrack,
        dumbbellTrack,
        resistanceBandTrack,
    ],
};

export default strengthForLifeData;
